import { getMyProfile } from "API/myPages";
import {
  createClient as APICreateClient,
  getClients,
  getClient as APIGetClient,
  updateClient as APIUpdateClient,
  getCompanySettings as APIGetCompanySettings,
  getShortInfoClients,
} from "API/swesum";
import { useAuth } from "Hooks/useAuth";
import { createContext, useContext, useState } from "react";

const ClientsContext = createContext(null);

export const ClientsContextProvider = ({ children }) => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(false);
  const [clientShortInfo, setClientShortInfo] = useState([]);
  const [hasFetchedAll, setHasFetchedAll] = useState(false);
  const [hasFetchedShortAll, setHasFetchedShortAll] = useState(false);
  const { authData } = useAuth();

  const fetchClients = async (force = false) => {
    setLoading(true);
    let data = [];
    if (hasFetchedAll && !force) {
      setLoading(false);
      return;
    }
    if (authData.userType === "client") {
      const client = await getMyProfile();
      data.push(client);
    } else {
      data = await getClients();
    }
    setClients(data);
    setHasFetchedAll(true);
    setLoading(false);
  };

  const fetchClientShortInfo = async (force = false) => {
    try {
      if (hasFetchedShortAll && !force) {
        return clientShortInfo;
      }
      const res = await getShortInfoClients();
      setClientShortInfo(res);
      setHasFetchedShortAll(true);
      return res;
    } catch (err) {
      return err;
    }
  };

  const getClientById = async (clientId) => {
    let client = clients.find(
      (client) => Number(client.Id) === Number(clientId)
    );
    if (!client) {
      client = await APIGetClient(clientId);
      const newClients = [...clients];
      newClients.push(client);
      setClients(newClients);
    }
    return client;
  };

  const getCompanySettings = async () => {
    setLoading(true);
    const companySettings = await APIGetCompanySettings();
    let companySetting = null;
    if (companySettings.length > 0) {
      const newClients = [...clients, companySettings[0]];
      setClients(newClients);
      companySetting = companySettings[0];
    }
    setLoading(false);
    return companySetting;
  };

  const createClient = async (data) => {
    setLoading(true);
    const res = await APICreateClient(data);
    setClients((prevClients) => [...prevClients, res.data]);
    setLoading(false);
    return res;
  };

  const updateClient = async (clientId, body) => {
    const res = await APIUpdateClient(clientId, body);
    const updatedClient = res.data;
    if (res.status === 201) {
      setClients((currentClients) =>
        currentClients.map((client) =>
          client.Id === updatedClient.Id
            ? { ...client, ...updatedClient }
            : client
        )
      );
    }
    return res;
  };

  return (
    <ClientsContext.Provider
      value={{
        clients,
        getCompanySettings,
        fetchClientShortInfo,
        clientShortInfo,
        hasFetchedAll,
        fetchClients,
        createClient,
        getClientById,
        updateClient,
        loading,
      }}
    >
      {children}
    </ClientsContext.Provider>
  );
};

export const useClients = () => useContext(ClientsContext);
